// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React, { useCallback, useContext } from 'react';
import type { FlattenSimpleInterpolation } from 'styled-components';
import styled from 'styled-components';
import { TextLink } from '@oneaudi/unified-web-components';
import type { CustomTheme } from '../../../@types/theme';
import { getClassNamesForLinks, getLinkTarget } from '../../services';
import { ServiceContext } from '../../context/ServiceContext';
import { AudiCopy1WithHoverStyle } from '../AudiHeader/AudiHeaderStyleUtils';
import type { AudiHeaderSubNavListItemProps } from '../../interfaces/header-components.interfaces';
import { subNavigationLinkClick } from '../../utils/tracking';
import { scriptRegex } from '../../utils/string-utils';
import { SUB_NAVIGATION_CLASSNAME } from '../../utils/globals';

const HeaderStyledSubNavListItem = styled.li<{
  isAudiSport: boolean;
  theme: CustomTheme;
}>`
  margin-bottom: var(--one-header-space-m);

  ${({ isAudiSport }): string =>
    isAudiSport &&
    `
    padding-left: 42px;
    position: relative;

    &::before {
      background-color: var(--one-header-color-red-rhombus);
      content: "";
      display: inline-block;
      height: 24px;
      left: 6px;
      position: absolute;
      transform: skew(-28deg);
      vertical-align: top;
      width: 24px;
      overflow: hidden;
    }
  `}
`;

const HeaderStyledSubNavListItemLink = styled.a`
  ${({ theme }): FlattenSimpleInterpolation => AudiCopy1WithHoverStyle(theme)}
  color: ${({ theme }): string => {
    return process.env.IS_LEGACY ? theme.colors.colorBaseGrey60 : theme.colors.colorSubNavLink;
  }};
  text-decoration: none;

  &:hover,
  &:active,
  &:focus {
    color: ${({ theme }): string =>
      theme.type === 'legacy' ? 'var(--one-header-color-black)' : ''};
  }
`;

const AudiHeaderSubNavListItem: React.FC<AudiHeaderSubNavListItemProps> = ({
  listItem,
  useFootnoteReferenceServiceTextParserHook,
  onItemClick,
  isSubNavOpen,
  useOneLayer,
  index,
  mainNavIndex,
}) => {
  const { trackingService } = useContext(ServiceContext);
  const dangerousHTML = useFootnoteReferenceServiceTextParserHook(
    listItem?.Text?.replace(scriptRegex, ' illegal script '),
  );

  const onClick = useCallback(
    (event) => {
      trackingService?.track(
        subNavigationLinkClick('click on link', event.currentTarget, index, mainNavIndex),
      );
      onItemClick(event, listItem);
    },
    [listItem, onItemClick],
  );

  return (
    <HeaderStyledSubNavListItem isAudiSport={listItem.IsAudiSport}>
      <HeaderStyledSubNavListItemLink
        aria-label={listItem.AriaLabel}
        title={listItem.Text}
        className={`${getClassNamesForLinks(listItem, useOneLayer)} ${SUB_NAVIGATION_CLASSNAME}`}
        href={listItem.Url}
        onClick={onClick}
        target={getLinkTarget(listItem)}
        data-index={index}
      >
        <span
          dangerouslySetInnerHTML={{
            __html: dangerousHTML,
          }}
        />
      </HeaderStyledSubNavListItemLink>
    </HeaderStyledSubNavListItem>
  );
};

export default AudiHeaderSubNavListItem;
